// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverCache, WeaverRelationIn, index,
    indexOf = [].indexOf;

  Weaver = require('./Weaver');

  WeaverRelationIn = require('./WeaverRelationIn');

  index = function(id, graph) {
    var node;
    if (id instanceof Weaver.Node) {
      node = id;
      id = node.id();
      graph = node.getGraph();
    }
    return `${id}@${graph || ''}`;
  };

  WeaverCache = class WeaverCache {
    static signature(idOrNode, graph) {
      return index(idOrNode, graph);
    }

    constructor() {
      this._map = {};
      this._pendingWrites = [];
      this._lastUpdate = void 0;
      this._eventListeners = {};
      // when query results are added do not send events immediately
      this._suppressEvents = false;
      this._suppressedEvents = [];
    }

    addEventListener(type, callback) {
      if (type !== 'update') {
        throw new Error(`Event type ${type} not supported`);
      }
      this._eventListeners[type] = [];
      return this._eventListeners[type].push(callback);
    }

    trigger(type, signature) {
      var callback, i, len, node, ref, results;
      if (this._suppressEvents) {
        return this._suppressedEvents.push({type, signature});
      } else {
        node = this.evokeNode(signature);
        node._lastUpdate = this._lastUpdate; // update non-deep field to help trigger update detection
        ref = this._eventListeners[type] || [];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          callback = ref[i];
          results.push(callback(signature));
        }
        return results;
      }
    }

    startSuppress() {
      return this._suppressEvents = true;
    }

    releaseSuppress() {
      var i, len, ref, signature, type;
      this._suppressEvents = false;
      ref = this._suppressedEvents;
      for (i = 0, len = ref.length; i < len; i++) {
        ({type, signature} = ref[i]);
        this.trigger(type, signature);
      }
      return this._suppressedEvents = [];
    }

    flushNode(id, graph) {
      var map, signature;
      signature = index(id, graph);
      map = this._map[signature] || (function() {
        throw new Error('This cache has nothing on this node');
      })();
      return map.node = void 0;
    }

    garbageCollect(keepAgeSeconds) {
      var destroyBefore, item, key, ref, ref1, ref2, ref3, relSignature, relation, relations, results, signature, sourceItem, sourceSignature, targetItem, targetSignature;
      destroyBefore = void 0;
      if (keepAgeSeconds != null) {
        destroyBefore = new Date().getTime() - keepAgeSeconds * 1000;
      }
      ref = this._map;
      // initially anotate each item for destroy
      for (signature in ref) {
        item = ref[signature];
        item._destroyMarker = true;
      }
      ref1 = this._map;
      // unset the anotation for the items to keep
      for (signature in ref1) {
        item = ref1[signature];
        if ((item.node != null) || item.timestamp > destroyBefore) {
          delete item._destroyMarker;
        }
      }
      ref2 = this._map;
      // todo: keep attribute nodes
      // todo: keep relation nodes, including to's and froms
      results = [];
      for (signature in ref2) {
        item = ref2[signature];
        if (!item._destroyMarker) {
          continue;
        }
        ref3 = item.relations;
        // remove references to this node
        for (key in ref3) {
          relations = ref3[key];
          for (relSignature in relations) {
            relation = relations[relSignature];
            sourceSignature = index(relation.sourceId, relation.sourceGraph);
            targetSignature = index(relation.targetId, relation.targetGraph);
            if (sourceSignature === relSignature) {
              targetItem = this._map[targetSignature];
              delete targetItem.relations[key][relSignature];
            }
            if (targetSignature === relSignature) {
              sourceItem = this._map[sourceSignature];
              delete sourceItem.relations[key][relSignature];
            }
          }
        }
        // remove this node
        results.push(delete this._map[signature]);
      }
      return results;
    }

    // will be called by query result handlers or node instance
    addNode(id, graph, creator, created) {
      var base, signature;
      signature = index(id, graph);
      if (this._map[signature] == null) {
        if ((base = this._map)[signature] == null) {
          base[signature] = {
            signature,
            id: id,
            graph: graph,
            creator,
            created,
            node: void 0, // keep pointer to the evoked Weaver.Node objects
            attributes: {},
            relations: {}
          };
        }
      }
      this._map[signature].timestamp = this._lastUpdate;
      return this._map[signature];
    }

    // will be called by query result handlers or node instance
    addAttribute(sourceId, sourceGraph, key, value, datatype, nodeId, nodeGraph) {
      var base, node, source;
      source = this.addNode(sourceId, sourceGraph);
      node = this.addNode(nodeId, nodeGraph);
      if ((base = source.attributes)[key] == null) {
        base[key] = {};
      }
      if (source.attributes[key][node.signature] == null) {
        source.attributes[key][node.signature] = {value, datatype, nodeId, nodeGraph};
        // is this node evoked
        if (source.node != null) {
          this.populateWithAttribute(source.node, key, {value, datatype}, node.signature);
          return this.trigger('update', index(sourceId, sourceGraph));
        }
      }
    }

    // will be called by query result handlers or node instance
    addRelation(sourceId, sourceGraph, key, targetId, targetGraph, nodeId, nodeGraph) {
      var base, base1, node, source, sourceNode, target, targetNode, updated;
      source = this.addNode(sourceId, sourceGraph);
      target = this.addNode(targetId, targetGraph);
      node = this.addNode(nodeId, nodeGraph);
      if ((base = source.relations)[key] == null) {
        base[key] = {};
      }
      updated = false;
      if (source.relations[key][node.signature] == null) {
        updated = true;
        source.relations[key][node.signature] = {sourceId, sourceGraph, targetId, targetGraph, nodeId, nodeGraph};
      }
      if ((base1 = target.relations)[key] == null) {
        base1[key] = {};
      }
      if (target.relations[key][node.signature] == null) {
        updated = true;
        target.relations[key][node.signature] = {sourceId, sourceGraph, targetId, targetGraph, nodeId, nodeGraph};
      }
      // is this node evoked
      if (updated && ((source.node != null) || (target.node != null))) {
        sourceNode = source.node || this.evokeNode(source.signature);
        targetNode = target.node || this.evokeNode(target.signature);
        this.populateWithRelation(sourceNode, key, targetNode, node.signature);
        this.trigger('update', index(targetId, targetGraph));
        return this.trigger('update', index(sourceId, sourceGraph));
      }
    }

    // will be called by node instance
    removeNode() {}

    // todo

    // will be called by node instance
    removeAttribute() {}

    // todo

    // will be called by node instance
    removeRelation() {}

    // todo
    evokeNode(signature, constructor = Weaver.Node) {
      var attSignature, attribute, attributes, evocation, key, map, ref, ref1, relSignature, relation, relations, sourceNode, sourceSignature, targetNode, targetSignature;
      map = this._map[signature] || (function() {
        throw new Error(`This cache has nothing on node ${signature}`);
      })();
      if (map.node != null) {
        return map.node;
      }
      evocation = new constructor(map.id, map.graph);
      evocation._clearPendingWrites();
      evocation._cache = this;
      evocation._createdAt = map.created;
      evocation._createdBy = map.creator;
      evocation._lastUpdate = this._lastUpdate;
      map.node = evocation;
      ref = map.attributes;
      for (key in ref) {
        attributes = ref[key];
        for (attSignature in attributes) {
          attribute = attributes[attSignature];
          this.populateWithAttribute(evocation, key, attribute, attSignature);
        }
      }
      ref1 = map.relations;
      for (key in ref1) {
        relations = ref1[key];
        for (relSignature in relations) {
          relation = relations[relSignature];
          sourceSignature = index(relation.sourceId, relation.sourceGraph);
          targetSignature = index(relation.targetId, relation.targetGraph);
          if (sourceSignature === signature && targetSignature === signature) {
            this.populateWithRelation(evocation, key, evocation, relSignature);
          } else if (sourceSignature === signature) {
            targetNode = this.evokeNode(targetSignature);
            this.populateWithRelation(evocation, key, targetNode, relSignature);
          } else if (targetSignature === signature) {
            sourceNode = this.evokeNode(sourceSignature);
            this.populateWithRelation(sourceNode, key, evocation, relSignature);
          }
        }
      }
      return evocation;
    }

    populateWithAttribute(source, key, attribute, attSignature) {
      var attNode, attributeEvocation, existing, record, ref;
      attNode = this.evokeNode(attSignature);
      attributeEvocation = source.attribute(key);
      if (attributeEvocation._cache == null) {
        attributeEvocation._cache = this;
      }
      existing = (function() {
        var i, len, ref, results;
        ref = attributeEvocation._records;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          record = ref[i];
          results.push(index(record.attNode));
        }
        return results;
      })();
      if (ref = index(attNode), indexOf.call(existing, ref) < 0) {
        record = new Weaver.Attribute.Record(source, attribute.value, attribute.datatype, attNode);
        return attributeEvocation._records.push(record);
      }
    }

    populateWithRelation(source, key, target, relSignature) {
      var base, existing, record, ref, ref1, relNode, relationEvocation;
      relNode = this.evokeNode(relSignature);
      relationEvocation = source.relation(key);
      if (relationEvocation._cache == null) {
        relationEvocation._cache = this;
      }
      existing = (function() {
        var i, len, ref, results;
        ref = relationEvocation._records;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          record = ref[i];
          results.push(index(record.relNode));
        }
        return results;
      })();
      if (ref = index(relNode), indexOf.call(existing, ref) < 0) {
        record = new Weaver.Relation.Record(source, target, relNode);
        relationEvocation._records.push(record);
      }
      relationEvocation = target.relationIn(key);
      if (relationEvocation._cache == null) {
        relationEvocation._cache = this;
      }
      existing = (function() {
        var i, len, ref1, results;
        ref1 = relationEvocation._records;
        results = [];
        for (i = 0, len = ref1.length; i < len; i++) {
          record = ref1[i];
          results.push(index(record.relNode));
        }
        return results;
      })();
      if (ref1 = index(relNode), indexOf.call(existing, ref1) < 0) {
        record = new Weaver.Relation.Record(source, target, relNode);
        relationEvocation._records.push(record);
        // should have been deprecated
        if ((base = target.relationsIn)[key] == null) {
          base[key] = new WeaverRelationIn(key);
        }
        return target.relationsIn[key].addSource(source);
      }
    }

  };

  // Export
  module.exports = WeaverCache;

}).call(this);
